export default "__VITE_ASSET__Cw6OW4yl__"